import {Loader} from "../parts/loader"

const $loader = new Loader()

window.customLoader = $loader